import { render, staticRenderFns } from "./ChevronDownLarge.vue?vue&type=template&id=b163481c"
import script from "./ChevronDownLarge.vue?vue&type=script&lang=js"
export * from "./ChevronDownLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports